<ng-template #tokenForm>
  <top-alert type="warning" message="Informe o token de 8 caracteres alfanuméricos para acessar. Geralmente localizado no rodapé do espelho do documento."></top-alert>
  <editable-form [form]="form!" noButton>
    <input-text [size]="12" password [control]="form!.controls.token" label="Token do documento" (change)="cdRef.detectChanges()"></input-text>
  </editable-form>
</ng-template>
<toolbar [title]="documento?.titulo || ''" [buttons]="buttons"></toolbar>
<top-alert *ngIf="documentoSalvo" type="success" message="Documento foi salvo com sucesso!"></top-alert>
<separator></separator>
<document-preview #documentPreview *ngIf="documento?.tipo && ['HTML', 'REPORT'].includes(documento!.tipo)" [html]="documento?.conteudo || ''" emptyDocumentMensage="Vazio"></document-preview>
<!--toolbar [buttons]="footerButtons"></toolbar/-->